export const getIsOffline = (state) => state.network.isOffline;
